import { render } from "./outStockDetails.vue?vue&type=template&id=5b37223c&scoped=true"
import script from "./outStockDetails.vue?vue&type=script&lang=js"
export * from "./outStockDetails.vue?vue&type=script&lang=js"

import "./outStockDetails.vue?vue&type=style&index=0&id=5b37223c&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b37223c"]])

export default __exports__